import "./HomeTriInfo.scss";
import { Fragment, useRef, useState } from "react";
import { baseUrl } from "../../../utils/apiData";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const HomeTriInfo = ({ dataList, title }) => {
  const slideRef = useRef();
  const navigate = useNavigate();
  const [view, setView] = useState(0);
  return (
    <section className="home_tri_info p_t">
      <div className="content_wrap">
        <h2 className="gold">
          {title &&
            title
              ?.split("")
              .map((char, k) => (
                <motion.span
                  initial={{ translateX: 24, opacity: 0 }}
                  whileInView={{ translateX: 0, opacity: 1 }}
                  transition={{
                    duration: 0.4,
                    ease: "easeInOut",
                    delay: 0.05 * k,
                  }}
                  key={k}
                >
                  {char}
                </motion.span>
              ))
              .concat("")}
        </h2>
      </div>
      {dataList?.length > 0 ? (
        <Fragment>
          {/* For Big screen size > = laptop */}
          <div className="stack_sec_big">
            {dataList?.map((project, k) => {
              return (
                <div
                  className={`project_card ${view === k ? "active" : ""}`}
                  key={project?._id}
                  onMouseEnter={() => setView(k)}
                >
                  <div className="img_wrap">
                    <img
                      src={`${baseUrl}/${project?.image}`}
                      alt="Project"
                      className="bg"
                    />
                  </div>
                  <div className="content_layer">
                    <h6 className="gold">{project?.name}</h6>
                    {view === k && (
                      <div className="bottom">
                        <motion.p
                          initial={{ translateX: -100, opacity: 0 }}
                          whileInView={{ translateX: 0, opacity: 1 }}
                          transition={{
                            duration: 0.4,
                            ease: "easeInOut",
                          }}
                          className="gold"
                        >
                          {project?.description}
                        </motion.p>
                        <motion.button
                          initial={{ translateX: -100, opacity: 0 }}
                          whileInView={{ translateX: 0, opacity: 1 }}
                          transition={{
                            duration: 0.4,
                            ease: "easeInOut",
                            delay: 0.15,
                          }}
                          type="button"
                          className="primary_btn"
                          onClick={() => {
                            navigate(`project/${project?.slug}`);
                          }}
                        >
                          <span>Read More</span>
                        </motion.button>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* For Small screen size < laptop */}
          <div className="laptop_stack">
            {dataList?.map((project, k) => {
              return (
                <div
                  className={`project_card ${view === k ? "active" : ""}`}
                  key={project?._id}
                  onMouseEnter={() => setView(k)}
                >
                  <div className="img_wrap">
                    <img
                      src={`${baseUrl}/${project?.image}`}
                      alt="Project"
                      className="bg"
                    />
                  </div>
                  <div className="content_layer">
                    <h6 className="gold">{project?.name}</h6>
                    {view === k && (
                      <div className="bottom">
                        <img
                          src={`${baseUrl}/${project?.logo}`}
                          alt="Logo"
                          className="logo"
                        />
                        <motion.p
                          initial={{ translateY: 24, opacity: 0 }}
                          whileInView={{ translateY: 0, opacity: 1 }}
                          transition={{
                            duration: 0.4,
                            ease: "easeInOut",
                          }}
                          className="gold"
                        >
                          {project?.description}
                        </motion.p>
                        <motion.button
                          initial={{ translateY: 24, opacity: 0 }}
                          whileInView={{ translateY: 0, opacity: 1 }}
                          transition={{
                            duration: 0.4,
                            ease: "easeInOut",
                            delay: 0.15,
                          }}
                          type="button"
                          className="primary_btn"
                          onClick={() => {
                            navigate(`project/${project?.slug}`);
                          }}
                        >
                          <span>Read More</span>
                        </motion.button>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </Fragment>
      ) : (
        <p className="text-center darkGold">Data not found...</p>
      )}
    </section>
  );
};

export default HomeTriInfo;
